import { render } from "./Aspect.vue?vue&type=template&id=4b691be2&ts=true"
import script from "./Aspect.vue?vue&type=script&lang=ts"
export * from "./Aspect.vue?vue&type=script&lang=ts"

import "./Aspect.vue?vue&type=style&index=0&id=4b691be2&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__